import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const ChangePassword = loadable(() => import(/* webpackChunkName: "ChangePassword" */ './ChangePassword'), {
  fallback: <LoadableFallback visible />,
});

const asyncChangePassword = ({ route }) => (
  <ChangePassword route={route} />
);

asyncChangePassword.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncChangePassword;
